module.exports = __webpack_public_path__ + "img/gratification-xml.3df0fac1.svg";